<div class="page">
  <div class="page-head">
    <div>
      <h2>{{ 'help.title' | translate }}</h2>
      <p class="page-sub">{{ 'help.subtitle' | translate }}</p>
    </div>
    <span class="spacer"></span>
    <button mat-button (click)="replayWelcome()">
      <mat-icon>replay</mat-icon> {{ 'help.replayWelcome' | translate }}
    </button>
  </div>

  <h3 class="section-title">{{ 'help.pages' | translate }}</h3>
  <div class="card-grid">
    <a class="help-card" *ngFor="let t of topics" [routerLink]="t.route">
      <mat-icon class="help-icon">{{ t.icon }}</mat-icon>
      <div class="help-title">{{ t.titleKey | translate }}</div>
      <div class="help-body">{{ t.bodyKey | translate }}</div>
    </a>
  </div>

  <h3 class="section-title">{{ 'help.yourRole' | translate }}</h3>
  <div class="table-wrap">
    <table class="data">
      <thead>
        <tr>
          <th>{{ 'help.colRole' | translate }}</th>
          <th>{{ 'help.colManageEmployees' | translate }}</th>
          <th>{{ 'help.colOrderCatering' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr [class.row-you]="role === 'owner'">
          <td>{{ 'help.roleOwner' | translate }}</td><td>{{ 'help.yes' | translate }}</td><td>{{ 'help.yes' | translate }}</td>
        </tr>
        <tr [class.row-you]="role === 'manager'">
          <td>{{ 'help.roleManager' | translate }}</td><td>{{ 'help.yes' | translate }}</td><td>{{ 'help.yes' | translate }}</td>
        </tr>
        <tr [class.row-you]="role === 'viewer'">
          <td>{{ 'help.roleViewer' | translate }}</td><td>{{ 'help.readOnly' | translate }}</td><td>{{ 'help.no' | translate }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <p class="page-sub" *ngIf="roleLabel">{{ 'help.signedInAsPrefix' | translate }} <strong>{{ roleLabel }}</strong>.</p>

  <h3 class="section-title">{{ 'help.whatFriggHandles' | translate }}</h3>
  <p class="page-sub">
    {{ 'help.whatFriggHandlesIntro' | translate }}
  </p>
  <ul class="help-list">
    <li>{{ 'help.handledGroups' | translate }}</li>
    <li>{{ 'help.handledCredit' | translate }}</li>
    <li>{{ 'help.handledInvoicing' | translate }}</li>
    <li>{{ 'help.handledPortalUsers' | translate }}</li>
  </ul>
</div>
